
export default class ClubImpersonalAccount {

    constructor() {
        this.id = null;
        this.number = '';
        this.label = '';
        this.isEditable = true;
        this.isDeletable = true;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubImpersonalAccount = new ClubImpersonalAccount();
        clubImpersonalAccount.id = data.id;
        clubImpersonalAccount.number = data.number;
        clubImpersonalAccount.label = data.label;
        if (data.isEditable !== undefined) {
            clubImpersonalAccount.isEditable = data.isEditable;
        }
        if (data.isDeletable !== undefined) {
            clubImpersonalAccount.isDeletable = data.isDeletable;
        }

        return clubImpersonalAccount;
    }

    showLabel() {
        return '(' + this.number + ')' + (this.label !== '' ? ' ' + this.label : '');
    }

    serialize() {
        return {
            id: this.id,
            number: this.number,
            label: this.label,
        }
    }
}
